import React, { Component } from 'react'
import Modal from './Modal'

class DatesModal extends Component {
  render () {
    return (
      <Modal title='Available dates'
             classModalHeader='b-modal-header_border'>
        <div className='b-flex'>
          <h3>Mo. 7. August</h3>
          <button className='b-button b-align_right' type='button'>Choose date
          </button>
        </div>
        <p>
          <span>16:00 - 18:30</span>
          <span>29,90 € {intl.get('experiences.per_person')}{intl.get('experiences.per_person')}</span>
        </p>
        <hr />
        <div className='b-flex'>
          <h3>Mo. 7. August</h3>
          <button className='b-button b-align_right' type='button'>Choose date
          </button>
        </div>
        <p>
          <span>16:00 - 18:30</span>
          <span>29,90 € per person</span>
        </p>
        <hr />
        <div className='b-flex'>
          <h3>Mo. 7. August</h3>
          <button className='b-button b-align_right' type='button'>Choose date
          </button>
        </div>
        <p>
          <span>16:00 - 18:30</span>
          <span>29,90 € per person</span>
        </p>
        <hr />
        <div className='b-flex'>
          <h3>Mo. 7. August</h3>
          <button className='b-button b-align_right' type='button'>Choose date
          </button>
        </div>
        <p>
          <span>16:00 - 18:30</span>
          <span>29,90 € per person</span>
        </p>
        <hr />
        <div className='b-flex'>
          <h3>Mo. 7. August</h3>
          <button className='b-button b-align_right' type='button'>Choose date
          </button>
        </div>
        <p>
          <span>16:00 - 18:30</span>
          <span>29,90 € per person</span>
        </p>
        <hr />
        <div className='b-flex'>
          <h3>Mo. 7. August</h3>
          <button className='b-button b-align_right' type='button'>Choose date
          </button>
        </div>
        <p>
          <span>16:00 - 18:30</span>
          <span>29,90 € per person</span>
        </p>
        <hr />
        <div className='b-flex'>
          <h3>Mo. 7. August</h3>
          <button className='b-button b-align_right' type='button'>Choose date
          </button>
        </div>
        <p>
          <span>16:00 - 18:30</span>
          <span>29,90 € per person</span>
        </p>
        <hr />
        <div className='b-flex'>
          <h3>Mo. 7. August</h3>
          <button className='b-button b-align_right' type='button'>Choose date
          </button>
        </div>
        <p>
          <span>16:00 - 18:30</span>
          <span>29,90 € per person</span>
        </p>
        <hr />
        <div className='b-flex'>
          <h3>Mo. 7. August</h3>
          <button className='b-button b-align_right' type='button'>Choose date
          </button>
        </div>
        <p>
          <span>16:00 - 18:30</span>
          <span>29,90 € per person</span>
        </p>
        <hr />
        <div className='b-flex'>
          <h3>Mo. 7. August</h3>
          <button className='b-button b-align_right' type='button'>Choose date
          </button>
        </div>
        <p>
          <span>16:00 - 18:30</span>
          <span>29,90 € per person</span>
        </p>

      </Modal>
    )
  }
}

export default DatesModal



// WEBPACK FOOTER //
// ./src/containers/DatesModal.js